import {AR_V2, CORE_AMZL} from "./Constants";
import {isReversePicklist} from "./Util";

export const AT_RISK = "At Risk";
export const MULTI_STATION_PICKLIST_TAG_LABEL = "Multi Station Picklist";
export const DELAYED_PICK = "Delayed Pick";
export const SIDELINED = "Sidelined";
export const ROUTE_CUT = "RouteCut";
export const ASSIGNABLE = "Assignable";
export const IN_PROGRESS = "In Progress";
export const PARTIALLY_PICKED = "Picked (partial)";
export const PICKED = "Picked";
export const MISSING = "Missing";
export const READY = "Ready";
export const NOT_READY = "Not Ready";
export const STAGED = "Staged";
export const DEPARTED = "Departed";
export const STOWED = "Stowed";
export const PRE_STAGED = "Pre Staged";
export const PARTIALLY_DEPARTED = "Departed (partial)";
export const PARTIALLY_STAGED = "Staged (partial)";
export const PENDING_PICK = "Picked (pending)";
export const PENDING_STAGE = "Staged (pending)";
export const STOW_PENDING = "Stow pending";
export const PICK_PENDING = "Pick pending";
export const PICK_IN_PROGRESS = "Pick in progress";
export const STAGE_PENDING = "Stage pending";
export const STAGE_IN_PROGRESS = "Stage in progress";
export const DEPART_IN_PROGRESS = "Depart in progress";
export const HIGH_RISK_STATUS = [ASSIGNABLE, NOT_READY];
export const NOT_ASSIGNED = "Not Assigned"
export const ASSIGNED = "Assigned";
export const PROGRESSING = "Progressing";
export const NOT_STARTED = "Not started";
export const ACTIVE = "ACTIVE"
export const LOGGED_OUT = "Logged Out"
export const ASSIGNMENT_AVAILABLE = "Available For Assignment";
export const ASSIGNMENT_BLOCKED = "Assignment Blocked";
export const DWELLING_PICKLIST = "Dwelling";
export const MANUALLY_ASSIGNED_PICKLIST = "Manually Assigned";
export const MANUALLY_PRIORITISED_PICKLIST = "Manually Prioritised";
export const OPTIMAL_ASSIGNMENT = "Assigned Optimally";
export const TIME_CRITICAL_PICKLIST = "Time Critical";
export const OVERCROWDED_AISLES = "Overcrowded Aisles";
export const FALLBACK_DASH = "-";
export const UNASSIGN_STAGER = "UNASSIGN_STAGER";
export const UNASSIGN_PICKER = "UNASSIGN_PICKER";

export const PICK_STATUS = {
    NOT_ASSIGNED: NOT_ASSIGNED,
    IN_PROGRESS: IN_PROGRESS,
    PICKED: PICKED,
    PARTIALLY_PICKED: PARTIALLY_PICKED,
    SIDELINED: SIDELINED
}

export const PICK_TYPE = {
    MULTI_STATION_PICKLIST: "MULTI_STATION_PICKLIST"
}

// Eligible statuses with dynamic routes along with zoned
export const PICK_STATUS_DYNAMIC = {
    NOT_ASSIGNED: NOT_ASSIGNED,
    IN_PROGRESS: IN_PROGRESS,
    PICKED: PICKED,
    PARTIALLY_PICKED: PARTIALLY_PICKED,
    SIDELINED: SIDELINED,
    NOT_READY: NOT_READY
}

export const PICK_STATUS_AR_V2 = {
    IN_PROGRESS: IN_PROGRESS,
    PICKED: PICKED,
    ROUTE_CUT: ROUTE_CUT,
    SIDELINED: SIDELINED,
    DELAYED_PICK: DELAYED_PICK,
}

export const PICK_STATUS_IN_GRID = {
    AVAILABLE: ASSIGNMENT_AVAILABLE,
    BLOCKED: ASSIGNMENT_BLOCKED,
    TIME_CRITICAL: TIME_CRITICAL_PICKLIST,
    OPTIMAL_ASSIGNMENT: OPTIMAL_ASSIGNMENT,
    MANUALLY_ASSIGNED: MANUALLY_ASSIGNED_PICKLIST,
    MANUALLY_PRIORITISED: MANUALLY_PRIORITISED_PICKLIST
};

export const PICK_ASSIST_STATUS = {
    ASSIGNED: "ASSIGNED",
    UNASSIGNED: "UNASSIGNED",
    REJECTED: "REJECTED"
};

export const PICK_ASSIST_SUPPORT_TYPE = {
    MANUALLY_PRIORITIZED: "MANUALLY_PRIORITIZED",
    HELP_REQUEST: "HELP_REQUEST",
    TEAM_LIFT_REQUEST: "TEAM_LIFT_REQUEST",
    OPTIMAL: "OPTIMAL"
};

export const AISLE_GROUP_STATUS = {
    AVAILABLE: ASSIGNMENT_AVAILABLE,
    BLOCKED: ASSIGNMENT_BLOCKED,
    OVERCROWDED: OVERCROWDED_AISLES
};

export const PICK_STATION_STATUS_AR_V2 = {
    ACTIVE: ACTIVE,
    LOGGED_OUT: LOGGED_OUT,
}

export const SIDELINE_ENABLED_STATES = [NOT_READY, ASSIGNABLE, IN_PROGRESS, DEPARTED, PARTIALLY_DEPARTED];
export const PRIORITIZE_ENABLED_STATES = [NOT_READY, ASSIGNABLE];
export const PICK_VISIBILITY_DROP_TO_CART_STATUS = [IN_PROGRESS, PICKED, PARTIALLY_PICKED];
export const GROCERY_PICK = "GROCERY_PICK";
export const SSD_PICK = "SSD_PICK";
export const RUSH_1_HR = "RUSH_1_HR";

export const PICKLIST_TAB = {
    GROCERY_PICK: "Grocery",
    SSD_PICK: "Core",
};

export const ROUTE_PICKLIST_PROGRESS = {
    [STAGED]: "stageProgress",
    [STAGE_PENDING]: "stageProgress",
    [STAGE_IN_PROGRESS]: "stageProgress",
    [PICK_PENDING]: "pickProgress",
    [PICK_IN_PROGRESS]: "pickProgress",
    [STOWED]: "stowProgress",
    [STOW_PENDING]: "stowProgress",
};

/**
 * Returns pick status for routes
 *
 * @param rswsRoute status returned by RSWS
 * @returns picking status
 */
export function getPickStatus(rswsRoute, capability, stationConfig, pickDurationInSeconds) {
    if (capability === AR_V2) {
        return getPickStatusForArV2Station(rswsRoute, pickDurationInSeconds);
    } else {
        return getPickStatusForOtherStations(rswsRoute, stationConfig);
    }
}

export function getPicklistProgress(picklist, stationConfig) {
    if (stationConfig && stationConfig.routeDetailsTabViewEnabled) {
        if (!picklist) return FALLBACK_DASH;
        const progressKey = ROUTE_PICKLIST_PROGRESS[getPickStatusForPicklist(picklist, stationConfig)];
        if (progressKey && picklist[progressKey]) {
            const { completedCount = 0, totalCount = 0 } = picklist[progressKey];
            return `${completedCount}/${totalCount}`;
        }
        return FALLBACK_DASH;
    }
    return picklist.pickProgress.completedCount + "/" + picklist.pickProgress.totalCount
}

/**
* Returns pick status for picklists
*
* @param picklist object in response from RSWS
* @returns picking status
*/
export function getPickStatusForPicklist(picklist, stationConfig) {
    if (stationConfig && stationConfig.routeDetailsTabViewEnabled) {
        if (!picklist || !picklist.status) return '...';
        switch (picklist.status) {
            case NOT_READY:
                return STOW_PENDING;
            case STOWED:
                return STOWED;
            case PENDING_PICK:
                return PICK_PENDING;
            case PARTIALLY_PICKED:
                return PICK_IN_PROGRESS;
            case PENDING_STAGE:
                return STAGE_PENDING;
            case PARTIALLY_STAGED:
                return STAGE_IN_PROGRESS;
            case STAGED:
                return STAGED;
            case SIDELINED:
                return SIDELINED;
            default:
                return picklist.status;
        }
    }
    if (picklist.status === ASSIGNABLE) {
        return PICK_STATUS.NOT_ASSIGNED;
    } else if (picklist.status === PICKED && picklist.pickProgress.completedCount !== picklist.pickProgress.totalCount) {
        return PICK_STATUS.PARTIALLY_PICKED;
    } else {
        return picklist.status;
    }
}

export function getNextWorkGroups(picklist) {
    if (!picklist || !picklist.workGroupSequence) return [];

    let nextWg = picklist.workGroupSequence
        .filter(item => item.workGroupStatus === "INACTIVE");

    if (!nextWg.length) return [];

    return nextWg.map(seq => seq.workGroupList.join(" | "));
}

function getPickStatusForArV2Station(rswsRoute, pickDurationInSeconds) {
    if (rswsRoute.sidelined) {
        return SIDELINED;
    } else if (rswsRoute.routeCut) {
        return ROUTE_CUT;
    } else if (!rswsRoute.pickStatus) {
        return IN_PROGRESS;
    } else if (rswsRoute.pickStatus === IN_PROGRESS) {
        // route is in Delayed pick status if it's In progress for more than 60 minutes
        const maxDurationAllowed = 60 * 60;
        if (pickDurationInSeconds && pickDurationInSeconds >= maxDurationAllowed){
            return DELAYED_PICK
        }
        return IN_PROGRESS;
    }
    return rswsRoute.pickStatus;
}

function getPickStatusForOtherStations(rswsRoute, stationConfig) {
    if (rswsRoute.sidelined) {
        return PICK_STATUS.SIDELINED;
    } else if (rswsRoute.routeStatus === NOT_READY && (stationConfig.drsPickStageVisibilityEnabled
        || isReversePicklist(rswsRoute))) {
        return PICK_STATUS_DYNAMIC.NOT_READY;
    } else if (rswsRoute.routeStatus === ASSIGNABLE) {
        return PICK_STATUS.NOT_ASSIGNED;
    } else if (rswsRoute.routeStatus === IN_PROGRESS) {
        return PICK_STATUS.IN_PROGRESS;
    } else if (isPartiallyPicked(rswsRoute, stationConfig)) {
        return PICK_STATUS.PARTIALLY_PICKED;
    }
    return PICK_STATUS.PICKED;
}

function isPartiallyPicked(rswsRoute, stationConfig) {
    if (stationConfig.pickStageDecoupleEnabled || !rswsRoute.pickProgressV2) {
        if (rswsRoute.pickProgress.totalCount && rswsRoute.pickProgress.completedCount < rswsRoute.pickProgress.totalCount) {
            return true;
        }
    } else if (rswsRoute.pickProgressV2.totalCount && rswsRoute.pickProgressV2.completedCount < rswsRoute.pickProgressV2.totalCount) {
        return true;
    }
    return false;
}

export function getPickStatusList(stationConfig) {
    if (stationConfig.drsPickStageVisibilityEnabled) {
        return Object.values(PICK_STATUS_DYNAMIC);
    }
    return Object.values(PICK_STATUS);
}

export function getPickStatusInGridList() {
    return Object.values(PICK_STATUS_IN_GRID);
}

export function getAisleGroupStatusList() {
    return Object.values(AISLE_GROUP_STATUS);
}

export function getPickStatusListARv2() {
    return Object.values(PICK_STATUS_AR_V2);
}

export function getPickStationStatusListARv2() {
    return Object.values(PICK_STATION_STATUS_AR_V2);
}
/**
 * Returns pick status indicator color
 *
 * @param status of route
 * @returns color
 */

export function getPickStatusColor(routeStatus) {
    switch (routeStatus) {
        case SIDELINED:
        case DELAYED_PICK:
            return "error";
        case ROUTE_CUT:
            return "warning";
        case PICK_STATUS.PICKED:
            return "success";
        case PICK_STATUS.PARTIALLY_PICKED:
        case PICK_STATUS.IN_PROGRESS:
            return "warning";
        case PICK_STATUS_DYNAMIC.NOT_READY:
            return "theme";
        default:
            return "neutral";
    }
}

/**
 * Returns the meridian Tag color for a pick assist status.
 *
 * @param status one of PICK_ASSIST_STATUS values
 * @returns Tag type
 */
export function getPickAssistStatusColor(status) {
    switch (status) {
        case PICK_ASSIST_STATUS.ASSIGNED:
            return "success";
        case PICK_ASSIST_STATUS.REJECTED:
            return "error";
        case PICK_ASSIST_STATUS.UNASSIGNED:
            return "neutral";
        default:
            return "neutral";
    }
}

/**
 * Returns the meridian Tag color for a pick assist support type.
 *
 * @param supportType one of PICK_ASSIST_SUPPORT_TYPE values
 * @returns Tag type
 */
export function getPickAssistSupportTypeColor(supportType) {
    switch (supportType) {
        case PICK_ASSIST_SUPPORT_TYPE.TEAM_LIFT_REQUEST:
            return "error";
        case PICK_ASSIST_SUPPORT_TYPE.HELP_REQUEST:
            return "warning";
        case PICK_ASSIST_SUPPORT_TYPE.MANUALLY_PRIORITIZED:
            return "theme";
        case PICK_ASSIST_SUPPORT_TYPE.OPTIMAL:
            return "success";
        default:
            return "neutral";
    }
}

/**
 * Returns the i18n message id and display label for a pick assist status.
 *
 * @param status one of PICK_ASSIST_STATUS values
 * @returns {{id: string, defaultMessage: string}}
 */
export function getPickAssistStatusLabel(status) {
    switch (status) {
        case PICK_ASSIST_STATUS.ASSIGNED:
            return {id: "pick.assistStatus.assigned", defaultMessage: "Assigned"};
        case PICK_ASSIST_STATUS.UNASSIGNED:
            return {id: "pick.assistStatus.unassigned", defaultMessage: "Unassigned"};
        case PICK_ASSIST_STATUS.REJECTED:
            return {id: "pick.assistStatus.rejected", defaultMessage: "Rejected"};
        default:
            return {id: "pick.assistStatus.unknown", defaultMessage: status};
    }
}

/**
 * Returns the i18n message id and display label for a pick assist support type.
 *
 * @param supportType one of PICK_ASSIST_SUPPORT_TYPE values
 * @returns {{id: string, defaultMessage: string}}
 */
export function getPickAssistSupportTypeLabel(supportType) {
    switch (supportType) {
        case PICK_ASSIST_SUPPORT_TYPE.MANUALLY_PRIORITIZED:
            return {id: "pick.assistType.manuallyPrioritized", defaultMessage: "Manually Prioritized"};
        case PICK_ASSIST_SUPPORT_TYPE.HELP_REQUEST:
            return {id: "pick.assistType.helpRequest", defaultMessage: "Help Request"};
        case PICK_ASSIST_SUPPORT_TYPE.TEAM_LIFT_REQUEST:
            return {id: "pick.assistType.teamLiftRequest", defaultMessage: "Team Lift Request"};
        case PICK_ASSIST_SUPPORT_TYPE.OPTIMAL:
            return {id: "pick.assistType.optimal", defaultMessage: "Optimal"};
        default:
            return {id: "pick.assistType.unknown", defaultMessage: supportType};
    }
}

/**
 * Returns route status
 *
 * @param rswsRoute status returned by RSWS
 * @param stationConfig dynamic config for feature control
 * @returns parsed status
 */
export function getRouteStatus(rswsRoute, stationConfig) {
    if (rswsRoute.sidelined) {
        return SIDELINED;
    } else if (rswsRoute.routeCut) {
        return ROUTE_CUT;
    } else if(stationConfig.splitStagingEnabled) {
        console.log("Split Staging Enabled");
        if (allCartsStaged(rswsRoute.carts)) {
            return STAGED;
        } else if (allCartsPreStaged(rswsRoute.carts)) {
            return PRE_STAGED;
        }
    }
    return rswsRoute.routeStatus;
}

function getCartStatus(cart) {
    return cart.preStageLocation ? PRE_STAGED : (cart.stageTime ? STAGED : cart.status)
}

function allCartsPreStaged(carts) {
    return carts && carts.length && carts.every(cart => getCartStatus(cart) === PRE_STAGED);
}

function allCartsStaged(carts) {
    return carts && carts.length && carts.every(cart => getCartStatus(cart) === STAGED);
}

/**
 * Updates route status to assignable if route is unassigned
 *
 * @param capability
 * @param routes
 * @param stationConfig
 * @returns updated routes
 */
export function handleUnassignedRoutes(capability, routes, stationConfig) {
    if (capability === CORE_AMZL && !stationConfig.parallelPickEnabled) {
        routes.forEach(route => {
            if (route.routeStatus === IN_PROGRESS && !route.activeAssignee) {
                route.routeStatus = ASSIGNABLE;
            }
            if (route.pickAssociates && route.pickAssociates.length > 0 && route.pickAssociates[0].pickingDuration < 0) {
                if (route.routeStatus === IN_PROGRESS) {
                    route.pickAssociates[0].pickingDuration = null;
                } else {
                    route.pickAssociates[0].pickingDuration *= -1;
                }
            }
        });
    }
    return routes;
}

/**
 * Returns route status indicator color
 *
 * @param status of route
 * @returns color
 */
export function getRouteStatusColor(routeStatus) {
    switch (routeStatus) {
        case SIDELINED:
            return "error";
        case ROUTE_CUT:
            return "warning";
        case DEPARTED:
            return "success";
        case STAGED:
            return "success";
        case ASSIGNABLE:
            return "neutral";
        default:
            return "warning";
    }
}

/**
 * Returns cart status
 *
 * @param cart object returned by GetRouteDetails Response (RSWS).
 * @returns parsed status
 */
export function getCartStatusARv2(rswsCart, routeStatus) {
    if (routeStatus === SIDELINED && !rswsCart.containerStates.includes("STAGED")) {
        return SIDELINED
    } else if (rswsCart.containerStates.includes("MISSED")) {
        return MISSING;
    } else if (rswsCart.containerStates.includes("STAGED")) {
        return STAGED;
    } else if (rswsCart.containerStates.includes("READY")) {
        return READY;
    }
    return NOT_READY;
}

/**
 * Checks if a route is incomplete and it has no in-progress picklist but some picklists are pending for pick.
 * Note: this is for parallel pick only
 *
 * @param route
 * @return {boolean}
 */
export function isRouteStalled(route) {
    if (route.status !== PICK_STATUS.IN_PROGRESS
        || !Array.isArray(route.picklists)
        || !route.picklists.length) {
        return false;
    }
    const inProgress = route.picklists.findIndex(picklist => picklist.status === PICK_STATUS.IN_PROGRESS);
    const notAssigned = route.picklists.findIndex(picklist => picklist.status === PICK_STATUS.NOT_ASSIGNED);
    return inProgress === -1 && notAssigned >= 0; //No in-progress but at-least one assignable picklist.
}

export const getPicklistTab = (picklist) => {
    /* workGroupSequenceList comes after 30s of splitting,
        during that time every picklist will be in Core tab. */
    if (!picklist.workGroupSequenceList || !picklist.workGroupSequenceList.length) {
        return "Core";
    }
    const tabTypes = new Set(
        picklist.workGroupSequenceList
            .map(group => PICKLIST_TAB[group.workGroupType])
            .filter(Boolean)
    );
    return tabTypes.size
        ? Array.from(tabTypes).sort().join(" & ")
        : "Core";
};



// WEBPACK FOOTER //
// ./src/components/util/EntityStatusManager.js